import * as React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { DemandCard } from './demand-card.js';
import type { Demand, DemandStage } from '../lib/demands-api.js';

export interface DemandColumnProps {
  readonly stage: DemandStage;
  readonly items: readonly Demand[];
  readonly now: Date;
  readonly onOpen: (id: string) => void;
  /** undefined = žádný přesun neprobíhá; jinak true/false podle `allowedTransitions` tažené karty. */
  readonly dropAllowed: boolean | undefined;
  /** Sloupec mimo konfiguraci kanceláře (viz `groupByStage`) — nesmí vypadat jako běžný. */
  readonly unknown?: boolean;
}

/**
 * Sloupec pipeline poptávek. `dropAllowed` se řídí `allowedTransitions`
 * z API (viz `demand-card.tsx`) — nepovolený cíl se v UI vůbec nenabídne,
 * server ho stejně odmítne.
 */
export function DemandColumn({
  stage,
  items,
  now,
  onOpen,
  dropAllowed,
  unknown = false,
}: DemandColumnProps): React.JSX.Element {
  const { setNodeRef } = useDroppable({ id: stage.key });
  const bodyClass =
    dropAllowed === undefined
      ? 'rh-kanban-column__body'
      : `rh-kanban-column__body ${dropAllowed ? 'rh-kanban-column__body--drop-ok' : 'rh-kanban-column__body--drop-no'}`;

  return (
    <div className="rh-kanban-column" data-testid={`demand-column-${stage.key}`}>
      <div className="rh-kanban-column__header">
        <span>{unknown ? stage.label : stage.label}</span>
        <span className="rh-badge rh-badge--neutral">{items.length}</span>
      </div>
      <div ref={setNodeRef} className={bodyClass}>
        {items.map((item) => (
          <DemandCard key={item.id} item={item} now={now} onOpen={onOpen} />
        ))}
      </div>
    </div>
  );
}
